<template>
  <div id="operationLog">
    <!-- 头部 -->
    <div class="head">
      <div class="head_left">
        <el-date-picker
          v-model="dateValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
      </div>
      <div class="head_right">
        <el-input
          v-grantShow="$store.state.SysGrant.GetAllAccountLog"
          v-model="operationLog_req.value"
          placeholder="请输入关键词"
          class="input-with-select"
          :clearable="true"
        >
          <template #append>
            <el-button icon="Search" @click="operationLogGet" />
          </template>
          <template #prepend>
            <el-select
              v-model="selectId"
              placeholder="Select"
              style="width: 100px"
            >
              <el-option
                v-for="(item, index) in selectData"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-input>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      ref="multipleTable"
      :data="operationLogData"
      tooltip-effect="dark"
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#F4F7FB' }"
      :header-row-style="{
        backgroundColor: '#F4F7FB',
        color: '#1E2026',
      }"
    >
      <el-table-column prop="id" label="ID" min-width="80"> </el-table-column>
      <el-table-column label="操作账号" min-width="150">
        <template #default="scope">
          <div>{{ scope.row.user.realname || "--" }}</div>
          <div>{{ scope.row.user.name || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="操作地址" min-width="150">
        <template #default="scope">
          <div>{{ scope.row.geo || "--" }}</div>
          <div>{{ scope.row.ip || "--" }}</div>
          
        </template>
      </el-table-column>
      <el-table-column min-width="150" show-overflow-tooltip>
        <template #header>
          <span :style="operationLog_req.type !== '' ? 'color:#059669;' : ''"
            >操作类型</span
          >
          <el-dropdown
            trigger="click"
            popper-class="dropdown"
            @command="handleCommand"
          >
            <el-icon><ArrowDown /></el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  command=""
                  :class="operationLog_req.type === '' ? 'index' : ''"
                  >全部</el-dropdown-item
                >
                <el-dropdown-item
                  :command="item.type"
                  :class="operationLog_req.type === item.type ? 'index' : ''"
                  v-for="item in operationLogType"
                  :key="item.type"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown></template
        >
        <template #default="scope">
          {{
            operationLogType[scope.row.type]
              ? operationLogType[scope.row.type].name
              : "--"
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作内容" min-width="400" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.content || "--" }}
        </template>
      </el-table-column>
      <el-table-column label="设备信息" min-width="150">
        <template #default="scope">
          <div>
            {{ scope.row.platform.os_name + scope.row.platform.os_ver || "--" }}
          </div>
          <div>
            {{
              scope.row.platform.browser_name +
                scope.row.platform.browser_ver || "--"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作时间" min-width="165">
        <template #default="scope">
          <template v-if="scope.row.time">
            {{ $moment(scope.row.time * 1000).format("yyyy-MM-DD HH:mm:ss") }}
          </template>
          <template v-else> -- </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <el-pagination
      background
      :pager-count="$store.state.screenWidth > 1200 ? 7 : 5"
      :page-sizes="[10, 20, 100, 200, 500, 1000]"
      layout="prev,pager,next,sizes,slot"
      v-model:current-page="operationLog_req.page"
      v-model:page-size="operationLog_req.page_max"
      :total="tableCount"
    >
      <div class="statistical">
        每页<b style="color: #ff0000">{{ operationLog_req.page_max }}</b
        >条/共<b style="color: #059669">{{ tableCount }}</b> 条数据
      </div>
    </el-pagination>
  </div>
</template>

<script setup>
import { reactive, ref, getCurrentInstance, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
//获取公共方法
let { proxy } = getCurrentInstance();
//全局数据
let vuex = useStore();
//操作日志请求参数
let operationLog_req = reactive({
  value: "",
  type: "",
  page: 1,
  page_max: 10,
});
//搜索类型
let selectData = {
  1: {
    label: "账号",
    value: 1,
    key: "tel",
  },
  2: {
    label: "操作内容",
    value: 2,
    key: "content",
  },
};
//搜索id
let selectId = ref(1);
//操作日志数据
let operationLogData = ref([]);
//操作日志类型
let operationLogType = ref({});
//操作日志总数
let tableCount = ref(0);
//时间范围
let dateValue = ref("");
//监听请求参数变化事件
watch(
  [
    () => operationLog_req.value,
    () => operationLog_req.page_max,
    () => dateValue.value,
    () => operationLog_req.type,
  ],
  async (newValue, oldValue) => {
    if (operationLog_req.page == 1) {
      operationLogGet();
    } else {
      operationLog_req.page = 1;
    }
  }
);
watch([() => operationLog_req.page], async (newValue, oldValue) => {
  operationLogGet();
});
//页面渲染事件
onMounted(() => {
  operationLogGet();
  operationLogTypeGet();
});
//操作日志类型获取
function operationLogTypeGet() {
  proxy.$http
    .get("webapi/account_log_mgr?item=types", {
      params: {},
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        res.data.forEach((item) => {
          operationLogType.value[item.type] = item;
        });
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//操作日志获取
function operationLogGet() {
  let req = {
    page: operationLog_req.page,
    page_max: operationLog_req.page_max,
    starttime: dateValue.value
      ? Math.ceil(dateValue.value[0].getTime() / 1000)
      : undefined,
    endtime: dateValue.value
      ? Math.ceil(dateValue.value[1].getTime() / 1000)
      : undefined,
    type: operationLog_req.type || undefined,
  };
  req[selectData[selectId.value].key] = operationLog_req.value;
  proxy.$http
    .get("webapi/account_log_mgr?item=list", {
      params: {
        ...req,
      },
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        tableCount.value = res.data.count;
        res.data.list.forEach((item) => {
          item.user = res.data.users.find((item2) => item2.id == item.uid);
          item.platform = res.data.platforms.find(
            (item2) => item2.id == item.pid
          );
        });
        operationLogData.value = res.data.list;
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//门店类型变换
function handleCommand(e) {
  operationLog_req.type = e;
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/log/operationLog.scss";
</style>